<template>
    <div :class="colGrid">
        <div class="card card-estilo p-grid p-fluid" :class="getClass" >
        
            <!-- <card-titulo :texto="titulo" :cor="cor" /> -->
            <h1 class="p-col-12" v-if="titulo">{{titulo}}</h1>

            <!-- Renderiza as tags filhas adicionadas ao componente -->
            <slot></slot>
            
        </div>
    </div>
</template>

<script>
import gridCss from '../common/grid'

export default {
    name: 'CargSeplag',
    props: ['titulo', 'cor', 'cols', 'classe'],
    computed: {
        colGrid() {
            return gridCss(this.cols ? this.cols : '12') 
        },
        getClass(){
            return this.classe
        }
    }
}
</script>

<style scoped>
.card-estilo {
    /* margin-top: 30px; */
    border-radius: 6px;
    box-shadow: 0 1px 4px 0 rgba(0,0,0,.14);
}

/* .card-estilo h1 {
    
    margin-bottom: 20px;
} */

</style>